<script setup>
import CostReportView from '@/components/accounting/CostReportView.vue'
import CostReportsGrid from '@/components/accounting/CostReportsGrid.vue'

import { useDetectDevice } from '@/composables/device'

const { isMobile } = useDetectDevice()
</script>
<template>
  <cost-report-view v-if="isMobile" />
  <cost-reports-grid v-else />
</template>
